module.exports = __webpack_public_path__ + "static/img/aws-cci-6.4b265dd9.png";